import StateInterface from "../redux-magic/state-interface";
import { SearchFilterId, SearchFilterOptionValueLocation } from "../redux-magic/sub-interfaces/search-types";

const generatePpsfRedirectUrl = (
	search_filter_state: StateInterface["search_filters_state"],
	router: any,
): string | null => {
	const appliedFilters = Object.keys(search_filter_state).filter(
		(key) => search_filter_state[key as SearchFilterId]?.is_applied,
	);
	if (appliedFilters.length === 0) return null;

	const queryParams = appliedFilters.reduce(
		(query, key) => {
			const { option_type, selected_options } = search_filter_state[key as SearchFilterId] || {};
			const selectedOption = selected_options?.[0]?.value;

			switch (option_type) {
				case "text":
					if (Array.isArray(selected_options) && selected_options.length > 0) {
						query[key] = selected_options.map((option) => option.value).join(",");
					}
					break;
				case "range":
					if (
						selectedOption &&
						typeof selectedOption === "object" &&
						"min" in selectedOption &&
						"max" in selectedOption
					) {
						query[key] = `${selectedOption.min}-${selectedOption.max}`;
					}
					break;
				case "location":
					if (selectedOption && typeof selectedOption === "object" && "coordinates" in selectedOption) {
						const { title, coordinates } = selectedOption as SearchFilterOptionValueLocation;
						query[key] = `${title},${coordinates[0]},${coordinates[1]}`;
					}
					break;
				default:
					break;
			}
			return query;
		},
		{} as Record<string, string>,
	);

	const queryString = new URLSearchParams(queryParams).toString();
	return `/search?${queryString}&locale=${router.locale || "en-IN"}`;
};

const PpsfFilterGenertateUrl = (search_filter_state: StateInterface["search_filters_state"], router: any) => {
	const ppsfRedirectURL = generatePpsfRedirectUrl(search_filter_state, router);
	if (ppsfRedirectURL) {
		const callbackUrl = encodeURIComponent(ppsfRedirectURL);
		const url = `${process.env.PRODUCTION_URL}loading.html?callbackUrl=${callbackUrl}`;
		window.location.href = url;
	}
};

export default PpsfFilterGenertateUrl;
